import React from 'react';
import { Canvas } from '@react-three/fiber';
import { CONFIG } from '../../index';

interface SceneCanvasProps {
  children: React.ReactNode;
}

export function SceneCanvas({ children }: SceneCanvasProps) {
  return (
    <Canvas
      style={{ position: 'absolute', inset: 0 }}
      camera={{ position: [CONFIG.camX, CONFIG.camY, CONFIG.camZ], up: [0, 0, 1], near: 0.1, far: 2000 }}
      gl={{ antialias: true, alpha: false }}
      frameloop="always"
    >
      {children}
    </Canvas>
  );
}
